'use client';

import { useContext } from 'react';
import { WizardContext } from '../contexts/WizardContext';
import type { WizardContextValue } from '../types';

/**
 * Hook to access the wizard context.
 *
 * Must be used within a WizardProvider.
 *
 * @returns The wizard context value containing state and dispatch
 * @throws Error if used outside of WizardProvider
 */
export function useWizardContext(): WizardContextValue {
  const context = useContext(WizardContext);

  if (!context) {
    throw new Error('useWizardContext must be used within a WizardProvider');
  }

  return context;
}
